import * as React from 'react'
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { SkuInfoBlock, ImageSkuBlock } from "@components"
import { useBuildExternalURL } from "@hooks"
import { useStockChangesShowEvolution } from '../@hooks'
import { StockChangesPriceEvolutionFilters } from '../../@signals'


export default function skuColumn() {
	return [{
		name: 'ean', label: 'Ean',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'Product Name',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'skuName', label: 'Product Name',
		options: {
			filter:false,
			headerAlign: 'center',
			customBodyRowRenderLite: (value, { category, brand, ean, skuID, productID, siteID, date, externalSeller, reference }) => {
				const { imageURL, productURL } = useBuildExternalURL({
					imageData: { skuID, siteID, productID, date },
					siteData: { siteID, productID }
				})
				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock imageURL={imageURL} />
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							category={category}
							brand={brand}
							ean={ean}
							reference={reference}
							productURL={productURL}
						/>
						<ShowPriceEvolutionCell siteID={siteID} productID={productID} skuID={skuID} externalSeller={externalSeller} />
					</Box>
				</Box>
			}
		}
	}]
}

const ShowPriceEvolutionCell = ({siteID, productID, skuID, externalSeller}) => {

	const { handleClickShowPriceEvolution, isOpenPriceEvolutionChart } = useStockChangesShowEvolution(siteID, productID, skuID, externalSeller)
	const isOpenChartClass = isOpenPriceEvolutionChart ? 'is-open' : ''

	return <Box data-tour-trigger className={`${isOpenChartClass}`} sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={() => handleClickShowPriceEvolution(StockChangesPriceEvolutionFilters)} >
		 <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
			 Show Price & Stock Evolution
		 </Typography>
		 <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
	</Box>
 
}